import { TAgent } from '~/features/agents/models'
import { EServerPath } from '~/models/api'

const compare = (a: number | string, b: number | string) => {
  if (b < a) {
    return -1
  }
  if (b > a) {
    return 1
  }
  return 0
}

export const getComparator = (
  orderC: 'asc' | 'desc',
  orderByC: keyof TAgent,
) => {
  return orderC === 'desc'
    ? (a: TAgent, b: TAgent) =>
        compare(String(b[orderByC]), String(a[orderByC]))
    : (a: TAgent, b: TAgent) =>
        compare(String(a[orderByC]), String(b[orderByC]))
}

export const stableSort = (
  array: TAgent[],
  comparator: (a: TAgent, b: TAgent) => number,
) => {
  const stabilizedThis = array.map(
    (el, index) => [el, index] as [TAgent, number],
  )
  stabilizedThis.sort((a, b) => {
    const orderC = comparator(a[0], b[0])
    if (orderC !== 0) return orderC
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

export const queryKeysUsers = {
  adminUsers: (filters: object = {}) => [EServerPath.adminUsers, filters],
  user: (userId: string) => [EServerPath.user, { userId }],
}
